import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
} from '@mui/material';

interface CreateIntegrationDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (code: string, networkCodes: string[]) => void;
}

// Диалог для создания новой интеграции
export const CreateIntegrationDialog: React.FC<
  CreateIntegrationDialogProps
> = ({ open, loading, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [networksRaw, setNetworksRaw] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!code.trim()) {
      setError(t('IntegrationsPage.Validation.CODE_REQUIRED') as string);
      return;
    }

    const networkCodes = networksRaw
      .split(/[\n,]/)
      .map((v) => v.trim())
      .filter(Boolean);

    onSubmit(code.trim(), networkCodes);
    setError('');
  };

  const handleClose = () => {
    if (loading) return;
    onClose();
    setCode('');
    setNetworksRaw('');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('IntegrationsPage.CreateDialog.TITLE')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label={t('IntegrationsPage.CreateDialog.CODE_LABEL')}
            fullWidth
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={loading}
            error={!!error}
            helperText={error}
            size="small"
          />
          <TextField
            label={t('IntegrationsPage.CreateDialog.NETWORKS_LABEL')}
            fullWidth
            value={networksRaw}
            onChange={(e) => setNetworksRaw(e.target.value)}
            disabled={loading}
            size="small"
            multiline
            minRows={3}
            placeholder={
              t('IntegrationsPage.CreateDialog.NETWORKS_PLACEHOLDER') as string
            }
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          {t('IntegrationsPage.Common.CANCEL')}
        </Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained">
          {t('IntegrationsPage.CreateDialog.SUBMIT')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateIntegrationDialog;
